import React from 'react'
import { Link } from 'react-router-dom';
import TitleBar from '../component/title/TitleBar'
import FeatuteImage from '../assets/blog/our_digestive_system.jpg'

const HumanDigestiveSystem = () => {
    return (
        <>
            <TitleBar pagetitle="Human Digestive System" breadcrumbs={
                <>
                    <Link to="/">Home</Link> &gt;
                    <Link to="/">Blogs</Link> &gt;
                    <Link to=""> Human Digestive System</Link>
                </>}
            />

            {/* About swatee pvt. ltd */}
            <div className='container px-4 my-12 flex sm:flex-col lg:flex-row'>
                <div className='basis-[70%] px-8'>
                    <img src={FeatuteImage} alt="/Swatee Logo" />
                    <h1 className='pt-6 text-[30px] py-8 text-primary'>
                        Human Digestive System
                    </h1>
                    <p className='text-justify'>
                        क्या कभी सोचा है कि जब आप एक रोटी या किसी भी फूड का एक कोर मुंह में लेकर चबाते हैं और जब वह पेट के अंदर जाकर पचता है, इस बीच किस तरह यह भोजन सफर करता है और कैसी प्रक्रियाओं से गुजरता है! चलिए आज इसी बारे में बात करते हैं… हमारा पाचन तंत्र हमारे शरीर के पॉवर हाउस की तरह है। क्योंकि हमारे शरीर को काम करने के लिए ऊर्जा भोजन के पाचन के बाद शरीर के इसी हिस्से से मिलती है। पाचन तंत्र द्वारा पूरे शरीर में भेजी गई ऊर्जा द्वारा ही हम अपने छोटे से लेकर बडे़ काम कर पाते हैं। आइए, जानते हैं कि किस तरह हमारा पाचन तंत्र हमारे शरीर के लिए काम करता है.!   सलाइवा यानी लार प्रड्यूस करने के मामले में हमारा डायजेस्टिव सिस्टम बहुत हैरान करता है। हमारे मुंह के अंदर हर रोज करीब 1 लीटर लार बनती है। जो हमें मुंह में पनपनेवाले हानिकारक बैक्टीरिया से बचाती है। हमारे भोजन को पचाने में सहायता करती है।  आखिर लार ही पाचन क्रिया की पहली सीढ़ी है। यह खाने के डायजेस्ट करने में मदद करती है। इसी की मदद से हम खाना चबा पाते हैं और इस खाने को पचाने में आंतों को आसानी होती है। क्योंकि लार या सलाइवा मिक्स होने के बाद भोजन का प्रकार और उसका तापमान दोनों पाचन के अनुकूल हो जाते हैं।  पाचन तंत्र के भाग-  हमारे पाचन तंत्र में छोटी आंत, बड़ी आंत, लीवर, मुंह, गला, भोजन नली सभी शामिल होते हैं।  भोजन पचाने की प्रक्रिया मुंह में कोर जाते ही इसे चबाने के साथ ही शुरू हो जाती है। इसलिए सलाइवा यानी लार का भोजन को पचाने में बहुत बड़ा योगदान होता है। पाचन के होते हैं दो प्रकार – हमारे शरीर में पाचन दो तरह से होता है। पहला प्रकार होता है मैकेनिकल और दूसरा प्रकार होता है केमिकल।  मैकेनिकल पाचन होता है, जब हम तोड़कर, चबाकर और दांतों के जरिए महीन पीसकर भोजन खाते हैं। जब दांत से पिसने के बाद भोजन पेट में चला जाता है तब इसे पचाने के लिए केमिकल प्रॉसेस शुरू होती है।  जब दांतों के जरिए पिसा हुआ भोजन जब पाचन तंत्र में पहुंचता है तो इसे एंजाइम्स द्वारा छोटे-छोटे मॉलेक्यूल्स में परिवर्तित किया जाता है। फिर इन्ही मॉलेक्यूल्स से ऊर्जा उत्पादित की जाती है।  सबसे अधिक काम करनेवाला भाग- हमारे पेट में डायजेशन यानी खाने को पचाने का सबसे अधिक काम छोटी आंत में होता है। जो कि हमारे पूरे डायजेस्टिव सिस्टम का करीब दो तिहाई हिस्सा है। अगर डायजेस्टिव सिस्टम से जुड़े हर अंग की आपस में मिलाकर इनकी लंबाई जोड़ दी जाए तो करीब 30 किलोमीटर की दूरी तय होगी। हैरान हो गए हैं ना ! लेकिन यह सच है कि मानव शरीर में प्रकृति ने बहुत सारे रहस्यों को एक साथ समेट दिया है। छोटी आंत ही शरीर का वह अंग है, जहां सबसे अधिक न्यूट्रिऐंट्स यानी पोषक तत्वों को अवशोषित किया जाता है। ताकि शरीर सेहतमंद रहे। यानी हमारी छोटी आंत बड़ा काम करती है।
                    </p>
                    {/* <ol className='text-[#5C727D] text-sm list-decimal mt-2 p-4 '>
                        <li className='p-1'>This company, SWATEE Health Solutions Private Limited, is a project of the SWATEE family.</li>
                        <li className='p-1'>The company's corporate office is located at H39, Shivalik Nagar, Haridwar, Uttarakhand, with the PIN code 249403.</li>
                        <li>The main branch office is situated near Gali No. 13 and 14, Chiddarwala, Punjab National Bank, on the main road between Rishikesh and Dehradun.</li>
                        <li className='p-1'>The director of the company is Miss Kusum Lata, and her permanent address is Nepali Farm, Rishikesh, Uttarakhand</li>
                        <li className='p-1'> The company is registered under the Company Act with registration number U74999UR2019OPC009795.</li>
                        <li className='p-1'>The PAN number of the company is ABCCS0684A, and the GSTIN is 05ABCCS0684A1ZS. </li>
                        <li className='p-1'>The company also holds an FSSAI License Number 12623005000005. </li>
                        <li className='p-1'>The company is also known by the abbreviation SHS. </li>
                    </ol> */}
                </div>
                <div className='basis-[30%]  ml-4 bg-[#f2f2f2] '>
                    <h2 className='py-2 sm:text-3xl text-lg text-white text-center bg-primary'>
                        IMPORATANT LINKS
                    </h2>
                    <ul className="text-primary px-8 py-8 list-disc">

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/terms-policies" >Swatee Terms and Policies</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/complaints-and-redressals" >Complaints and Redressals</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/" >Advisory Committee</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/login" >Admin Login</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/return-policy" >Return Policy</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/shipping-policy" >Shipping Policy</Link>
                        </li>
                    </ul >
                    <h2 className='mt-12 py-2 sm:text-3xl text-lg text-white text-center bg-primary'>
                        SWATEE GROUP
                    </h2>
                    <ul className="text-primary px-8 py-8 list-disc">

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/swatee-jyotish-peeth" >Swatee Jyotish Peeth</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/" >Swatee Health Solutions PVT. LTD</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/swatee-yogpeeth" >Swatee YogPeeth</Link>
                        </li>

                        <li className='p-1'>
                            <Link className=' hover:text-secondary' to="/swatee-ayur-jyoti" >Swatee Ayur Jyoti</Link>
                        </li>
                    </ul >
                </div>
            </div>
        </ >
    )
}

export default HumanDigestiveSystem
